import { ca } from '@cian/analytics';

interface ITrackDeleteFavorite {
  label: string;
  offerId: number;
}

export function trackDeleteFavorite({ label, offerId }: ITrackDeleteFavorite) {
  return ca('eventSite', {
    name: 'oldevent',
    category: 'favorite',
    action: 'remove_from_compare',
    label,
    products: [{ id: offerId, offerType: 'offer' }],
  });
}
